import React, { Component } from "react"
import "./userProfileKnowCred.scss"
import { generatePath, Link } from "react-router-dom"
import AddOutlined from "@material-ui/icons/AddOutlined"
import * as routes from "../../../../../library/constants/routes"
import { KeyboardArrowRight } from "@material-ui/icons"
import { bindActionCreators } from "redux"
import { lastKnowCredsList } from "../../../../../library/store/actions/creators/knowCredsCreators"
import { connect } from "react-redux"
import { withSnackbar } from "notistack"
import getErrorText from "../../../../../library/constants/errorTypes"
import LockOutlined from "@material-ui/icons/LockOutlined"

class UserProfileKnowCred extends Component {
  state = {
    list: [],
    counter: this.props.userInfo.knowcreds_number,
    dataReceived: false,
  }

  setStateAsync(state) {
    return new Promise((resolve) => {
      this.setState(state, resolve)
    })
  }

  async componentDidMount() {
    const {
      auth: { userData },
    } = this.props
    const { id } = this.props.userInfo

    try {
      if (this.props.type === "my-profile") {
        await this.props.lastKnowCredsList({
          list_type: "my",
          token: userData.token,
          user_id: userData.id,
        })
        await this.setStateAsync({
          list: this.props.knowCreds.myLastKnowCredsList,
          dataReceived: true,
        })
      } else {
        await this.props.lastKnowCredsList({
          list_type: "person",
          token: userData.token,
          user_id: id,
        })
        await this.setStateAsync({
          list: this.props.knowCreds.lastKnowCredsList,
          dataReceived: true,
        })
      }
    } catch ({ error }) {
      this.props.enqueueSnackbar(getErrorText(error.code), { variant: "error" })
    }
  }

  render() {
    const { counter, dataReceived, list } = this.state
    const { userInfo, type } = this.props

    const knowCredCreateLink =
      type === "my-profile"
        ? routes.KNOWCRED_CREATE
        : {
            pathname: routes.KNOWCRED_CREATE,
            search: `?for=${userInfo.id}`,
          }

    if (!dataReceived) {
      return null
    } else {
      if (!list.length) return null

      return (
        <div className="box user-profile-knowcred">
          <div className="f aic jcsb full-width">
            {/*<Link to={generatePath(routes.KNOWCRED, {userId: this.props.userInfo.id})} >KnowCred <span className="color-black-54">{counter}</span></Link>*/}
            <Link
              to={generatePath(routes.KNOWCRED, {
                userId: this.props.userInfo.id,
              })}
            >
              Creds
            </Link>
            {userInfo.is_friend || this.props.type === "my-profile" ? (
              <Link to={knowCredCreateLink} className="btn btn--plain">
                <AddOutlined /> Add Cred
              </Link>
            ) : null}
          </div>
          <div className="user-profile-knowcred__list">
            {list.map((knowCred) => (
              <Link
                to={generatePath(routes.KNOWCRED_SINGLE, {
                  knowCredId: knowCred.id,
                })}
                className="user-profile-knowcred__list-item"
                key={knowCred.id}
              >
                {!knowCred.public && (
                  <div className="knowcred-card__lock-icon">
                    <LockOutlined className="color-primary" />
                  </div>
                )}
                <img
                  src={knowCred.background_image}
                  className="user-profile-knowcred__background"
                  style={{ borderColor: knowCred.border_color }}
                />
                <img
                  src={knowCred.foreground_image}
                  className="user-profile-knowcred__foreground"
                />
              </Link>
            ))}
          </div>
          <div className="full-width d-none-xs">
            <Link
              to={generatePath(routes.KNOWCRED, {
                userId: this.props.userInfo.id,
              })}
              className="btn btn--plain"
            >
              Show all <KeyboardArrowRight />
            </Link>
          </div>
        </div>
      )
    }
  }
}

const mapStateToProps = ({ auth, person, knowCreds }) => ({
  auth,
  person,
  knowCreds,
})
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ lastKnowCredsList }, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withSnackbar(UserProfileKnowCred))
